const images = require.context(".", false, /\.jpg$/);

const slides = images
  .keys()
  .sort()
  .map((path) => images(path));

export default slides;
